import createIcon from '../../createIcon';

/**
 * @component @name BorderInner
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAyMUg1VjE5SDNWMjFaTTcgMjFIOVYxOUg3VjIxWk01IDdIM1Y5SDVWN1pNMyAxN0g1VjE1SDNWMTdaTTkgM0g3VjVIOVYzWk01IDNIM1Y1SDVWM1pNMTcgM0gxNVY1SDE3VjNaTTE5IDlIMjFWN0gxOVY5Wk0xOSAzVjVIMjFWM0gxOVpNMTUgMjFIMTdWMTlIMTVWMjFaTTEzIDNIMTFWMTFIM1YxM0gxMVYyMUgxM1YxM0gyMVYxMUgxM1YzWk0xOSAyMUgyMVYxOUgxOVYyMVpNMTkgMTdIMjFWMTVIMTlWMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderInner = createIcon('BorderInner', [
  [
    'path',
    {
      d: 'M3 21H5V19H3V21ZM7 21H9V19H7V21ZM5 7H3V9H5V7ZM3 17H5V15H3V17ZM9 3H7V5H9V3ZM5 3H3V5H5V3ZM17 3H15V5H17V3ZM19 9H21V7H19V9ZM19 3V5H21V3H19ZM15 21H17V19H15V21ZM13 3H11V11H3V13H11V21H13V13H21V11H13V3ZM19 21H21V19H19V21ZM19 17H21V15H19V17Z',
      key: 'yhaibk',
    },
  ],
]);

export default BorderInner;
